export default __webpack_public_path__ + "static/media/header-close.1570dca9.svg";